import type { OEMDataItem } from '@/vdp/Modals/FeaturesAndSpecsModal/OEMPanel';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';

export default function useGetOEMData() {
  const {
    installedPackages = [],
    installedOptions = [],
    standardEquipment = []
  } = useGetVehicleDetails();

  const hasInstalledPackages = installedPackages.length > 0;
  const hasInstalledOptions = installedOptions.length > 0;
  const hasStandardEquipment = standardEquipment.length > 0;
  const showOEMData =
    hasInstalledPackages || hasInstalledOptions || hasStandardEquipment;

  const maybeOEMData: Array<OEMDataItem | null> = [
    hasInstalledPackages
      ? {
          title: 'Installed Packages',
          data: installedPackages.map(pack => ({
            name: pack.name,
            options: pack.options
          }))
        }
      : null,
    hasInstalledOptions
      ? {
          title: 'Installed Options',
          data: [
            { name: '', options: installedOptions.map(option => option.name) }
          ]
        }
      : null,
    hasStandardEquipment
      ? {
          title: 'Standard Equipment',
          data: [{ name: '', options: [...standardEquipment] }]
        }
      : null
  ];

  return {
    showOEMData,
    oemData: maybeOEMData.filter((data): data is OEMDataItem => Boolean(data))
  };
}
